import { useEffect, useState } from 'react';

import {
  parseQueryString,
  parseAmplifyConfig,
  useAuth,
  cloneSearchParams,
} from '@warden-ui/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CupixWorksApi } from "@warden-ui/api";
import { CPPageBody } from '@warden-ui/common-components';
import { CardContentUserUpdate } from '@warden-ui/card-components';
import { CupixWorksDomainPostfix } from '@warden-ui/common';
import { useTranslation } from 'react-i18next';

const defaultQueryString: { [key: string]: string } = {
  config: '',
  region: '',
  team_domain: '',
  team_name: '',
  active: 'false',
  clear: 'false',
};

export default function UserUpdate() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const [t] = useTranslation();
  const navigate = useNavigate();
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [teamDomain, setTeamDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const cupixWorksApiEndpoint =
      amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      return;
    }

    setTeamDomain(
      `${queryString.team_domain}${CupixWorksDomainPostfix(
        cupixWorksApiEndpoint,
      )}`,
    );
  }, []);

  const redirectTo = () => {
    const params = cloneSearchParams(searchParams);
    navigate(`/redirect?${params.toString()}`);
  };

  const onClickSave = (firstname: string, lastname: string) => {
    const cupixWorksApiEndpoint =
      amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      return;
    }

    setLoading(true);
    auth
      .fetchAuthSession(amplifyConfig)
      .then((authSession) => {
        const accessToken = authSession.tokens?.accessToken.toString();
        if (!accessToken) {
          throw new Error('Access token is not found.');
        }

        return new CupixWorksApi(cupixWorksApiEndpoint).updateUser(
          queryString.team_domain,
          accessToken,
          firstname,
          lastname,
          !queryString.active
        );
      })
      .then((userSession) => {
        console.log("updated User", userSession);
        return redirectTo();
      })
      .catch((error) => {
        console.error(error.message);
        setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CPPageBody>
      <CardContentUserUpdate
        activeUser={queryString.active}
        teamDomain={teamDomain}
        teamName={queryString.team_name}
        onClickSave={onClickSave}
        loading={loading}
        errorMessage={errorMessage}
      />
    </CPPageBody>
  );
}
